export const encode = (data) => {
   return Object.keys(data)
      .map(
         (key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
      )
      .join('&');
};
